<template>
    <div>
        <rkm-table
            :items="linhas"
            :fields="fields"
        >
            <template v-slot:head(percentualFinanceiro)>
                % Cota Financeira
                <rkm-icon
                    icon="info"
                    color="secondary"
                    class="infor"
                    small
                    v-rkm-popover.hover.top="{
                        html: true,
                        content: 'Informe o percentual da cota que poderá ser consumido pelo APP Cidadão. Esse limite controla o canal cidadão e não representa reserva exclusiva do aplicativo.'
                    }"
                />
            </template>

            <template v-slot:head(percentualFisico)>
                % Cota Física
                <rkm-icon
                    icon="info"
                    color="secondary"
                    class="infor"
                    small
                    v-rkm-popover.hover.top="{
                        html: true,
                        content: 'Informe o percentual da cota que poderá ser consumido pelo APP Cidadão. Esse limite controla o canal cidadão e não representa reserva exclusiva do aplicativo.'
                    }"
                />
            </template>

            <template v-slot:cell(percentualFinanceiro)="{ item }">
                <span v-if="item.cotaTipoId !== enums.tipoCota.VALOR">-</span>
                <rkm-form-input
                    v-else
                    :value="getPercentual(item.infraestruturaId, item.cotaTipoId)"
                    @input="setPercentual(item.infraestruturaId, item.cotaTipoId, $event)"
                    number
                    placeholder="0 a 100"
                    class="mb-0"
                />
            </template>

            <template v-slot:cell(percentualFisico)="{ item }">
                <span v-if="item.cotaTipoId !== enums.tipoCota.QUANTIDADE">-</span>
                <rkm-form-input
                    v-else
                    :value="getPercentual(item.infraestruturaId, item.cotaTipoId)"
                    @input="setPercentual(item.infraestruturaId, item.cotaTipoId, $event)"
                    number
                    placeholder="0 a 100"
                    class="mb-0"
                />
            </template>

            <template v-slot:cell(totalApp)="{ item }">
                {{ getTotalApp(item) }}
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    color="secondary"
                    small
                    title="Ver detalhe por período"
                    @click="$refs.ModalDetalhe.open(item)"
                >
                    <rkm-icon icon="eye" />
                </rkm-button>
            </template>
        </rkm-table>

        <ModalDetalhe
            ref="ModalDetalhe"
            :cotas="data.model.cotas || []"
            :prestadores="data.model.appConectasusCidadaoPrestadores || []"
        />
    </div>
</template>

<script>
import ModalDetalhe from './ModalDetalhe'

import tipoCota from '@/enums/exame-imagem/tipoCota'

export default {
    components: { ModalDetalhe },
    computed: {
        linhas() {

            const rows = []

            ;(this.data.model.cotas || []).forEach(cota => {

                const tiposPresentes = [...new Set(cota.cotaSolicitante.map(c => c.cotaTipoId))]

                tiposPresentes.forEach(tipoId => {

                    const cotasDoTipo = cota.cotaSolicitante.filter(c => c.cotaTipoId === tipoId)
                    const isValor = tipoId === this.enums.tipoCota.VALOR

                    let quantidade

                    if (isValor) {

                        const total = cotasDoTipo.reduce((sum, c) => {

                            const v = parseFloat(String(c.cotaValor).replace(/\./g, '').replace(',', '.')) || 0

                            return sum + v
                        }, 0)

                        quantidade = 'R$ ' + Number(total).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

                    } else {

                        quantidade = cotasDoTipo.reduce((sum, c) => sum + (Number(c.cotaUnidade) || 0), 0)
                    }

                    rows.push({
                        nomeFantasia: cota.nomeFantasia,
                        infraestruturaNome: cota.infraestruturaNome,
                        infraestruturaId: cota.infraestruturaId,
                        quantidade,
                        quantidadeRaw: isValor
                            ? cotasDoTipo.reduce((sum, c) => {
                                const v = parseFloat(String(c.cotaValor).replace(/\./g, '').replace(',', '.')) || 0
                                return sum + v
                            }, 0)
                            : cotasDoTipo.reduce((sum, c) => sum + (Number(c.cotaUnidade) || 0), 0),
                        tipo: isValor ? 'Valor' : 'Quantidade',
                        cotaTipoId: tipoId,
                    })
                })
            })

            return rows
        },
    },
    data: () => ({
        enums: { tipoCota },
        fields: [
            { key: 'nomeFantasia', label: 'Prestador', sortable: true },
            { key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true },
            { key: 'quantidade', label: 'Quantidade', sortable: true },
            { key: 'tipo', label: 'Tipo da cota', sortable: true },
            { key: 'percentualFinanceiro', label: '' },
            { key: 'percentualFisico', label: '' },
            { key: 'totalApp', label: 'Total APP' },
            { key: 'actions', label: 'Ações', class: 'col-min' },
        ],
    }),
    methods: {
        getTotalApp(item) {

            const percentual = this.getPercentual(item.infraestruturaId, item.cotaTipoId)

            if (percentual === null || percentual === '' || percentual === undefined) return '-'

            if (item.cotaTipoId === this.enums.tipoCota.VALOR) {

                const total = item.quantidadeRaw * Number(percentual) / 100

                return 'R$ ' + total.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            }

            return Math.floor(item.quantidadeRaw * Number(percentual) / 100)
        },
        getPercentual(infraestruturaId, cotaTipoId) {

            const entry = (this.data.model.appConectasusCidadaoPrestadores || [])
                .find(e => e.infraestruturaId === infraestruturaId)

            if (!entry) return null

            return cotaTipoId === this.enums.tipoCota.VALOR
                ? entry.percentualFinanceiro
                : entry.percentualQuantitativo
        },
        setPercentual(infraestruturaId, cotaTipoId, value) {

            if (!this.data.model.appConectasusCidadaoPrestadores) {
                this.$set(this.data.model, 'appConectasusCidadaoPrestadores', [])
            }

            let entry = this.data.model.appConectasusCidadaoPrestadores
                .find(e => e.infraestruturaId === infraestruturaId)

            if (!entry) {

                entry = { infraestruturaId, percentualFinanceiro: null, percentualQuantitativo: null }

                this.data.model.appConectasusCidadaoPrestadores.push(entry)
            }

            const parsed = value !== '' && value !== null ? Number(value) : null

            if (cotaTipoId === this.enums.tipoCota.VALOR) {
                entry.percentualFinanceiro = parsed
            } else {
                entry.percentualQuantitativo = parsed
            }
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>

<style scoped>
    .infor {
        color: #acacac;
        height: 15px;
        width: 15px !important;
        border-radius: 31px;
        padding: 3px;
        border: 1px solid #c2c2c2;
        vertical-align: middle;
        margin-left: 4px;
    }
</style>
